import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { createEntityStateSlice } from "features/Application/slices/createEntityStateSlice";
import { type EntityState } from "interfaces/state/entityState";

const initialState: EntityState = {
  entityId: 0,
  changingEntityState: false,
  isPublished: false,
  error: undefined,
  lastModifiedDateTime: undefined,
  isEntityCommandInProgress: false,
};

const campaignEntityStateSlice = createEntityStateSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ThreatDefenceCampaigns,
    name: "entityState",
  },
  initialState,
  reducers: {},
});

export const {
  beginAction,
  successAction,
  createDraftSuccess,
  publishSuccess,
  revertSuccess,
  failureAction,
  resetState,
  updateBegin,
  updateSuccess,
  resetUpdate,
  setEntityId,
  openEntityDetails,
} = campaignEntityStateSlice.actions;

export default campaignEntityStateSlice.reducer;
